<template>
	<div>
		<template v-if="this.working_items == null || Object.keys(this.working_items).length > 0">
			<table cellspacing="0" cellpadding="0" border="0" class="basket_table">
				<tr>
					<th></th>
					<th colspan="2">Item</th>
					<th>Bid</th>
					<th></th>
				</tr>
				<tr v-for="item in working_items" v-bind:key="item.id">
					<td class="checkbox">
						<input type="checkbox" v-model="finalise_rows" :value="item.model_id" :id="item.model_id">
						<label :for="item.model_id"></label>
					</td>
					<td class="image">
						<img :src="item.model.thumbnail" width="100" height="75">
					</td>
					<td class="name">
						{{ 'Lot ' + item.model.lot_no + (item.model.suffix ? item.model.suffix : '') }}:
						<a :href="item.model.full_slug">{{ item.model.description }}</a>
						<br><small>Est: &pound;{{ item.model.low_est }} - &pound;{{ item.model.high_est }}</small>
					</td>
					<td class="bid">
						<div>
							<span class="currency">&pound;</span>
							<input name="bid" v-model="item.extra.bid" v-on:input="debounceInputBid(item)">
						</div>
					</td>
					<td class="remove"><button type="button" v-on:click="removeBasketItem(item.id)"><i class="fal fa-trash-alt"></i></button></td>
				</tr>
			</table>
			<p style="text-align: right;"><button style="button" class="button solid arrow" :class="{disabled:  finalise_rows.length==0}" v-on:click="finaliseBids()">Finalise selected bids</button></p>

			<form :action="destination" method="post" id="finalise_form">
				<input type="hidden" v-model="finalise_rows" name="finalise_rows">
			</form>
		</template>
		<p v-else>Your bid basket is currently empty.</p>
	</div>
</template>
<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';
export default {

	directives: {debounce},

	props: [
		'destination'
	],

	computed: {
		...mapGetters({
			refreshStatus: 'getMinicartRefreshStatus'
		})
	},
  
	data: () => {
		return {
			working_items: null,
			finalise_rows: [],
		}
	},

	mounted() {
		this.getBasketContents();
	},

	methods: {
		...mapActions(['minicartRefresh','addAlert']),

		getBasketContents: function() {	
			axios.get('/ajax/getBasketContents/true')
			.then(response => {
				this.working_items = response.data['basket'];
				if (response.data['message']!=null) {
					this.alert( response.data['message'], 'danger' );
					this.$store.commit('updateMinicartRefreshStatus', true);
				}
			})
			.catch(error => {
			});
		},

		debounceInputBid:  debounce(function(item) {
			this.inputBid(item);
		},1000),

		inputBid: function(item) {
			var self = this;
			if (item.extra.bid == '') { return false; }
			if (item.extra.bid == '0') { this.removeBasketItem(item.id); return false; }

			var round_to_nearest = 1;
			switch (true) {
				case (item.extra.bid < 40):
					self.alert('<strong>Sorry!</strong> The minimum bid is £40.', 'danger');
					return;
					break;
				case (item.extra.bid < 200):
					round_to_nearest = 10;
					break;
				case (item.extra.bid < 500):
					round_to_nearest = 20;
					break;
				case (item.extra.bid < 1000):
					round_to_nearest = 50;
					break;
				case (item.extra.bid < 2000):
					round_to_nearest = 100;
					break;
				case (item.extra.bid < 5000):
					round_to_nearest = 200;
					break;
				default:
					round_to_nearest = 500;
			}
			item.extra.bid = round_to_nearest * Math.floor(item.extra.bid / round_to_nearest);

			
			// post bid update
			axios.post('/ajax/updateBasketItem', {
				id: item.id, 
				bid: item.extra.bid
			})
			.then(response => {
				if (response.data === 'success') {
					self.getBasketContents();
				}else{
					// error
					self.alert('<strong>Error!</strong> Your updated bid could not be saved. Please try again.', 'danger' );
				}
				self.$store.commit('updateMinicartRefreshStatus', true);
			})
			.catch(error => {
				console.log(error);
			});
		},

		removeBasketItem: function(id) {
			var self = this;
			// display popup
			$.alert({
				title: 'Wait!',
				content: 'Are you sure you want to delete your bid?',
				buttons: {
					No: {
						text: 'No',
						action: function () {
							self.getBasketContents();
						}
					},
					Yes: {
						text: 'Yes',
						btnClass: 'btn-blue',
						action: function () {
							axios.post('/ajax/removeBasketItem', {
								id: id
							})
							.then(response => {
								if (response.data === 'success') {
									self.getBasketContents();
									self.$store.commit('updateMinicartRefreshStatus', true);
								}else{
								}
							})
							.catch(error => {
								console.log(error);
							});
						}
					}
				}
			});
		},

		finaliseBids: function() {
			if(this.finalise_rows.length==0) {
				this.alert( '<strong>Whoops!</strong> Please select which bids you wish to finalise.', 'danger' );
			}else{
				$('#finalise_form').submit();
			}
		},


		format_currency: function(value){
			return "£" + this.numberWithCommas((Math.round( (Number(value) + 0.0001) * 100 ) / 100).toFixed(2));
		},
		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

	}
};
</script>